import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { MailboxType } from 'owa-client-ids';
import { FullCompose } from 'owa-mail-compose-view';
import { messageAdListViewStatusStore } from 'owa-mail-messagead-list-store';
import { MessageAdReadingPane } from 'owa-mail-messagead-readingpane-view';
import { ReadingPane } from 'owa-mail-reading-pane-view';
import { previewPaneStore } from 'owa-preview-pane-store';
import { MIN_PREVIEW_PANE_WIDTH, MIN_READING_PANE_WIDTH } from 'owa-preview-pane-store';
import { lazySetReadingPaneSize, lazyUpdateReadingPaneSize } from 'owa-preview-pane-store';
import { PreviewPane } from 'owa-preview-pane-view';
import { lazyTriggerResizeEvent } from 'owa-resize-event';
import { ResizeHandle } from 'owa-resize-handle';
import { getActiveTab, TabType } from 'owa-tab-store';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';
import * as React from 'react';
import { composeStore, lazyCreateReply, lazyLoadDraftToCompose } from 'owa-mail-compose-store';
import strings from 'owa-strings/owa-mail-strings';
var styles = require('./ReadingPaneContainer.scss');
var classNames = require('classnames/bind').bind(styles);
var ReadingPaneContainer = /** @class */ (function (_super) {
    tslib_1.__extends(ReadingPaneContainer, _super);
    function ReadingPaneContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadDraftToCompose = function (itemId) {
            return !composeStore.defaultViewState || composeStore.defaultViewState.itemId.Id != itemId.Id
                ? lazyLoadDraftToCompose.importAndExecute(itemId.Id)
                : null;
        };
        _this.createReply = function (referenceItemId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var mailboxInfo, groupId, message, itemId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mailboxInfo = referenceItemId.mailboxInfo;
                        groupId = mailboxInfo && mailboxInfo.type == MailboxType.GroupMailbox
                            ? mailboxInfo.mailboxId
                            : null;
                        return [4 /*yield*/, lazyCreateReply.import()];
                    case 1: return [4 /*yield*/, (_a.sent())(referenceItemId.Id, true /*isReplyAll*/, groupId)];
                    case 2:
                        message = _a.sent();
                        itemId = tslib_1.__assign({}, message.ItemId, { mailboxInfo: referenceItemId.mailboxInfo });
                        return [2 /*return*/, itemId];
                }
            });
        }); };
        _this.onPreviewPaneMounted = function () {
            lazyTriggerResizeEvent.importAndExecute();
        };
        _this.onWindowResize = function () {
            if (previewPaneStore.state) {
                lazyUpdateReadingPaneSize.importAndExecute();
            }
        };
        _this.onResize = function (leftPaneDimension, rightPaneDimension) {
            lazySetReadingPaneSize.importAndExecute(leftPaneDimension, rightPaneDimension);
            lazyTriggerResizeEvent.importAndExecute();
        };
        _this.onWindowScrollForIEOnly = function () {
            var showSxS = _this.props.showSxS;
            _this.owaSxSDiv.style.left = showSxS ? -window.pageXOffset + 'px' : '';
        };
        return _this;
    }
    ReadingPaneContainer.prototype.render = function () {
        if (this.props.useLegacySxS || !isAttachmentFeatureEnabled('doc-SxS-refactor')) {
            return this.renderWithLegacySxS();
        }
        return (React.createElement("div", { tabIndex: -1, role: 'main', "aria-label": strings.contentPaneLabel, className: styles.showTabBar }, this.renderReadingPane(false)));
    };
    // This will be removed once doc-SxS-refactor flight is on by default
    ReadingPaneContainer.prototype.renderWithLegacySxS = function () {
        var _this = this;
        var showSxS = this.props.showSxS;
        var hideSxSReadingPane = false;
        var mainClasses = null;
        var leftPaneClasses = null;
        var previewPaneStyles = {};
        var rightPaneStyles = {};
        var style = {};
        if (showSxS) {
            hideSxSReadingPane = previewPaneStore.hideReadingPane;
            mainClasses = this.getMainCssClasses();
            leftPaneClasses = classNames(hideSxSReadingPane ? 'hideReadingPane' : null, 'owaSxSLeftPane');
            if (!hideSxSReadingPane && previewPaneStore.readingPaneSize) {
                previewPaneStyles = { width: previewPaneStore.previewPaneSizePixels + 'px' };
                rightPaneStyles = { width: previewPaneStore.readingPaneSizePixels + 'px' };
            }
            style = {
                width: previewPaneStore.previewPaneSizePixels + previewPaneStore.readingPaneSizePixels,
            };
        }
        else {
            mainClasses = styles.showTabBar;
        }
        return (React.createElement("div", { tabIndex: -1, role: 'main', "aria-label": strings.contentPaneLabel, className: mainClasses, ref: function (ref) { return (_this.owaSxSDiv = ref); }, style: style },
            showSxS && this.renderPreviewPane(leftPaneClasses, previewPaneStyles),
            showSxS && !hideSxSReadingPane && React.createElement(ResizeHandle, { onResize: this.onResize }),
            (!showSxS || !hideSxSReadingPane) && (React.createElement("div", { className: showSxS ? 'owaSxSRightPane' : null, style: tslib_1.__assign({}, rightPaneStyles, { minWidth: MIN_READING_PANE_WIDTH }), "data-min-width": MIN_READING_PANE_WIDTH }, this.renderReadingPane(showSxS)))));
    };
    ReadingPaneContainer.prototype.getMainCssClasses = function () {
        if (this.props.getMainCssClasses) {
            return this.props.getMainCssClasses();
        }
        return 'owaSxS';
    };
    ReadingPaneContainer.prototype.renderPreviewPane = function (cssClass, previewPaneStyles) {
        if (this.props.renderPreviewPane) {
            return this.props.renderPreviewPane(cssClass, previewPaneStyles, this.onPreviewPaneMounted, this.loadDraftToCompose, this.createReply);
        }
        // loadDraftToCompose is used when the user edits an attachment in WAC
        // - we need the draft to enter compose mode when this happens
        return (React.createElement(PreviewPane, { mainCssClass: cssClass, style: tslib_1.__assign({}, previewPaneStyles, { minWidth: MIN_PREVIEW_PANE_WIDTH }), viewState: previewPaneStore.state, loadDraftToCompose: this.loadDraftToCompose, createReply: this.createReply, didMountCallback: this.onPreviewPaneMounted }));
    };
    ReadingPaneContainer.prototype.renderReadingPane = function (showSxS) {
        var renderContent = null;
        var activeTab = getActiveTab();
        // If in dumpster or dumpster search, should always show reading pane (no compose)
        if (this.props.isDumpsterOrDumpsterSearchTable) {
            renderContent = (React.createElement(ReadingPane, { isDumpsterOrDumpsterSearchTable: this.props.isDumpsterOrDumpsterSearchTable }));
        }
        else {
            // Priority for content to be loaded into the Reading Pane:
            // 0. If there is custom RP content (renderReadingPane defined as a prop)
            // 1. If a message ad has been clicked.
            // 2. If we're in tab view and have an activate tab matching these types.
            // 3. If a full compose is open.
            // 4. Render the base reading pane out of the store.
            if (this.props.renderReadingPane) {
                renderContent = this.props.renderReadingPane();
            }
            else if (messageAdListViewStatusStore.selectedAdId) {
                renderContent = (React.createElement(MessageAdReadingPane, { selectedAdRowId: messageAdListViewStatusStore.selectedAdId }));
            }
            else if (activeTab &&
                (activeTab.type == TabType.Compose ||
                    activeTab.type == TabType.SecondaryReadingPane)) {
                // TODO: render all types of tab using this.renderTabContent()
                renderContent = this.renderTabContent(activeTab);
            }
            else if (composeStore.defaultViewState &&
                !composeStore.defaultViewState.isInlineCompose) {
                renderContent = React.createElement(FullCompose, { viewState: composeStore.defaultViewState });
            }
            else {
                renderContent = (React.createElement(ReadingPane, { isDumpsterOrDumpsterSearchTable: this.props.isDumpsterOrDumpsterSearchTable }));
            }
        }
        return React.createElement("div", { className: showSxS ? 'owaSxSConversation' : null }, renderContent);
    };
    ReadingPaneContainer.prototype.renderTabContent = function (tab) {
        var content = null;
        switch (tab.type) {
            case TabType.Compose:
                var composeViewState = tab.data;
                content = (React.createElement(FullCompose, { key: composeViewState.composeId, viewState: composeViewState }));
                break;
            case TabType.SecondaryReadingPane:
                content = (React.createElement(ReadingPane, { isDumpsterOrDumpsterSearchTable: this.props.isDumpsterOrDumpsterSearchTable }));
                break;
        }
        return content;
    };
    ReadingPaneContainer.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onWindowResize);
        // The owaSxS div uses position:fixed to be located top left under OWA header.
        // In other browsers when position:fixed is relative to the top-level
        // window, so if body has a min-width and overflow-x:auto applied, the
        // owaSxS div will keeps its position relative to the OWA header as body
        // scrolls horizontally. However this is not the case with IE, where
        // position:fixed is always relative to the top left of the browser viewport.
        // So for IE we have to implement the required scroll.
        if (isBrowserIE()) {
            window.removeEventListener('scroll', this.onWindowScrollForIEOnly);
        }
    };
    ReadingPaneContainer.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onWindowResize);
        if (isBrowserIE()) {
            window.addEventListener('scroll', this.onWindowScrollForIEOnly);
        }
        this.previousShowSxS = this.props.showSxS;
    };
    ReadingPaneContainer.prototype.componentDidUpdate = function () {
        var currentShowSxS = this.props.showSxS;
        if (this.previousShowSxS != currentShowSxS) {
            // Trigger the resize event when exiting SxS. We don't do this here for entering SxS.
            // PreviewPane is a lazy component and may not be in view yet when entering SxS. It calls onPreviewPaneMounted when mounted.
            if (this.previousShowSxS) {
                lazyTriggerResizeEvent.importAndExecute();
            }
            // In either case, update the previous vaule.
            this.previousShowSxS = currentShowSxS;
        }
    };
    ReadingPaneContainer = tslib_1.__decorate([
        observer
    ], ReadingPaneContainer);
    return ReadingPaneContainer;
}(React.Component));
export default ReadingPaneContainer;
//# sourceMappingURL=ReadingPaneContainer.js.map